import { Routes } from '@angular/router';
import { PagesComponent } from './pages/pages/pages.component';
import { PageEditorComponent } from './pages/pages/page-editor/page-editor.component';
import { UsersComponent } from './pages/users/users.component';
import { LoginComponent } from './pages/login/login.component';
import { WebsiteSelectorComponent } from './components/website-selector/website-selector.component';
import { ProductsComponent } from './pages/products/products.component';
import { EditProductComponent } from './pages/products/edit-product.component';
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';
import { rootGuard } from './guards/root.guard';
import { RootRedirectComponent } from './components/root-redirect/root-redirect.component';
import { PostsComponent } from './pages/posts/posts.component';
import { EditPostComponent } from './pages/posts/edit-post.component';
import { ImportPostsComponent } from './pages/posts/import-posts.component';
import { CategoriesComponent } from './pages/posts/categories.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { MenuPageComponent } from './pages/menu/menu.component';
import { MediaComponent } from './pages/media/media.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { EditProjectComponent } from './pages/projects/edit-project.component';
import { KnowledgeBaseComponent } from './pages/knowledge-base/knowledge-base.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

export const routes: Routes = [
  {
    path: '',
    component: RootRedirectComponent,
    canActivate: [rootGuard],
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  { 
    path: 'pages', 
    component: PagesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'pages/:paginanaam',
    component: PageEditorComponent,
    canActivate: [authGuard]
  },
  {
    path: 'menu',
    component: MenuPageComponent,
    canActivate: [authGuard]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'media',
    component: MediaComponent,
    canActivate: [authGuard]
  },
  {
    path: 'knowledge-base',
    component: KnowledgeBaseComponent,
    canActivate: [authGuard]
  },
  {
    path: 'knowledge-base/:categoryId/:articleId',
    component: KnowledgeBaseComponent,
    canActivate: [authGuard]
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'projects/edit/:id',
    component: EditProjectComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'posts', 
    component: PostsComponent,
    canActivate: [authGuard],
    data: { roles: ['superadmin', 'admin', 'editor'] }
  },
  {
    path: 'posts/categories',
    component: CategoriesComponent,
    canActivate: [authGuard],
    data: { roles: ['superadmin', 'admin', 'editor'] }
  },
  {
    path: 'posts/import',
    component: ImportPostsComponent,
    canActivate: [authGuard],
    data: { roles: ['superadmin', 'admin'] }
  },
  {
    path: 'posts/edit/:id',
    component: EditPostComponent,
    canActivate: [authGuard],
    data: { roles: ['superadmin', 'admin', 'editor'] }
  },
  { 
    path: 'users', 
    component: UsersComponent,
    canActivate: [authGuard],
    data: { roles: ['admin'] }
  },
  {
    path: 'websites',
    component: WebsiteSelectorComponent,
    canActivate: [authGuard]
  },
  {
    path: 'webshop',
    component: ProductsComponent,
    canActivate: [authGuard],
    data: { roles: ['admin'] }
  },
  {
    path: 'webshop/edit/:id',
    component: EditProductComponent,
    canActivate: [authGuard],
    data: { roles: ['admin'] }
  }
];
